App.directive('navSidebar', ['$window', 'Config', '$state', 'insuranceService', 'profileService', '$timeout', '$mdDialog', 'authService', function ($window, Config, $state, insuranceService, profileService, $timeout, $mdDialog, authService) {
    return {
        restrict: 'AEC',
        scope: {
        	
        },
        templateUrl: Config.TEMPLATES_DIR + 'nav-sidebar.html',
        link: function(scope) {
            scope.goVariant = function() {
                $timeout(function() {
                    if (!$('.menu.menu_2').hasClass('open')) {
                        $('a[target=".menu_2"]').trigger('click');
                        $state.go('root.life.variant');
                    } else {
                        $state.go('root.life.variant');
                    }
                }, 0);
            };

            // @TODO <HEALTH2019>
            scope.goVariantHealth = function() {
                $timeout(function() {
                    if (!$('.menu.menu_healthPzuw').hasClass('open')) {
                        $('a[target=".menu_healthPzuw"]').trigger('click');
                        $state.go('root.health.variant');
                    } else {
                        $state.go('root.health.variant');
                    }
                }, 0);
            };
            // @TODO </HEALTH2019>

            scope.logout = function() {
                authService.logout().then(function (data) {
                    if (data.status === 200) {
                        clearSession();
                    } else {
                        // scope.showPopUp('', 'Błąd wylogowania', 'Nie udało sie poprawnie wylogować konta. W przypadku problemów, prosimy o kontakt.', '', '');
                        clearSession();
                    }
                });
            };

            function clearSession() {
                window.sessionStorage.removeItem('isLogged');
                window.sessionStorage.removeItem('token');
                window.sessionStorage.removeItem('params');
                window.sessionStorage.removeItem('userObject');
                $rootScope.__logged = false;
                $rootScope.__isAccess = false;
                $rootScope.__isInsurer = false;
                $state.go('root.login');
            }

            scope.soon = function() {
                scope.showPopUp('', '', 'Funkcjonalność dostępna wkrótce', '', '', false);
            }

            scope.showPopUp = function(ev, head, content, text, target, reload) {
                $mdDialog.show({
                    controller: PopUpInfoCtrl,
                    templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-small.html',
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    locals: {
                        reload: reload,
                        head: head,
                        content: content,
                        button: {
                            text: text,
                            target: target
                        }
                    }
                }).then(function(data) {

                }, function() {

                });
            }

            function PopUpInfoCtrl($scope, $mdDialog, locals, $state) {
                $scope.locals = locals;

                $scope.hide = function() {
                    if ($scope.locals.reload) {
                        $state.reload();
                    }
                    $mdDialog.hide();
                };

                $scope.cancel = function() {
                    if ($scope.locals.reload) {
                        $state.reload();
                    }
                    $mdDialog.cancel();
                };

                $scope.confirm = function() {
                    if ($scope.locals.reload) {
                        $state.reload();
                    }
                    $mdDialog.hide($scope.locals);
                };
            }
        }
    };
}]);
